import { type FC, useState } from 'react';

import Menu from '@mui/icons-material/Menu';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';

import { IconButton } from '@craft/ui/components/buttons';
import { Box, Stack } from '@craft/ui/components/structural';

import { CraftSideNav } from '@/src/components/molecules/CraftSideNav';
import { CraftLogo } from '@/src/components-v2/brand/CraftLogo';

export const CraftMobileSideNav: FC = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const iOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent);

  return (
    <>
      <Box color='primary.contrastText'>
        <IconButton
          aria-label='drawer toggle'
          color='inherit'
          data-testid='menu-btn'
          id='menu-btn'
          onClick={() => setDrawerOpen(value => !value)}
        >
          <Menu color='inherit' />
        </IconButton>
      </Box>
      <SwipeableDrawer
        disableDiscovery={iOS}
        onClose={() => setDrawerOpen(false)}
        onOpen={() => setDrawerOpen(true)}
        open={drawerOpen}
      >
        <Stack
          height='100%'
          maxHeight='100%'
          role='presentation'
          sx={{ overflow: 'hidden' }}
          width='258px'
        >
          <CraftSideNav
            flexGrow={1}
            gap={0.5}
            maxWidth='100%'
            minHeight={0}
            role='menu'
            sx={{ '& > .MuiDivider-root': { marginBottom: 0, marginTop: 0 }, overflowY: 'auto' }}
            tabIndex={0}
            width='100%'
          />
          <Stack flexShrink={0}>
            <Stack
              alignItems='center'
              direction='row'
              justifyContent='center'
              paddingBottom={2}
              paddingTop={2}
              paddingX={4}
            >
              <CraftLogo size={{ width: '100%' }} />
            </Stack>
          </Stack>
        </Stack>
      </SwipeableDrawer>
    </>
  );
};
